import { useTranslation } from "react-i18next";

const stats = [
  { icon: "ri-code-s-slash-line", key: "devs", value: "50,000+", accent: true },
  { icon: "ri-chat-3-line", key: "msgs", value: "200M+", accent: false },
  { icon: "ri-github-line", key: "stars", value: "13,000+", accent: false },
  { icon: "ri-global-line", key: "countries", value: "80+", accent: false },
];

export default function AboutStats() {
  const { t } = useTranslation();
  return (
    <section className="py-14 border-b" style={{ borderColor: "var(--border-color)", backgroundColor: "var(--bg-surface)" }}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.key} className="text-center">
              <div
                className="w-10 h-10 flex items-center justify-center rounded-lg mx-auto mb-3"
                style={{
                  backgroundColor: s.accent ? "rgba(34,197,94,0.12)" : "var(--border-color)",
                  color: s.accent ? "var(--accent)" : "var(--text-nav)",
                }}
              >
                <i className={`${s.icon} text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold mb-1" style={{ color: "var(--text-primary)" }}>
                {s.value}
              </div>
              <div className="text-sm" style={{ color: "var(--text-muted)" }}>
                {t(`about.stat.${s.key}`)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}